import api from '@/api'

// State（状態）
// https://next.vuex.vuejs.org/ja/guide/state.html
// 状態を監視するデータ
const state = () => ({
  data: {},
  list: [],
})

// Getters（算出プロパティ）
// https://next.vuex.vuejs.org/ja/guide/getters.html
// コンポーネントから状態を取得するプロパティまたは関数
const getters = {
  results: (state) => state.data.results,
  prev: (state) => state.data.previous,
  next: (state) => state.data.next,
  list: (state) => state.list,
}

// Mutations（状態変更）
// https://next.vuex.vuejs.org/ja/guide/mutations.html
// 状態を変更するメソッド
const mutations = {
  setData: (state, data) => (state.data = data),
  clearData: (state) => (state.data = []),
  setList: (state, list) => (state.list = list),
  clearList: (state) => (state.list = []),
}

// Actions（処理）
// https://next.vuex.vuejs.org/ja/guide/actions.html
// コンポーネントからミューテーションを実行する関数
const actions = {
  clearAll({ commit }) {
    return new Promise((resolve) => {
      commit('clearData')
      resolve()
    })
  },
  /**
   * 一覧データを取得する
   *
   * @param {object}
   * @return {object}
   */
  async fetchAll({ commit }, queryParams) {
    const response = await api.get('manage/purchase/defective-items/', {
      params: queryParams,
    })
    commit('setData', response.data)
  },
  /**
   * 集計用データを取得する
   *
   * @param {object} queryParams
   * @return {object}
   */
  async fetchAggregate({ commit }, queryParams) {
    try {
      const response = await api.get(
        'manage/purchase/defective-items/aggregate/',
        {
          params: queryParams,
        }
      )
      commit('setList', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  /**
   * データを一括更新する
   *
   * @param {array} ids
   * @return {void}
   */
  async updateAll(_, ids) {
    try {
      const response = await api.patch(
        'manage/purchase/defective-items/bulk-update/',
        ids
      )
      return response.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
